import { VehicleState } from '@shared/vehicleSlice';
import { DeepReadonly } from 'ts-essentials';
import { JourneyProgressStatus } from '../models/protobuf/Journey';

export default function isVehicleOffRoute(
  vehicleState: DeepReadonly<VehicleState>,
): boolean {
  return (
    vehicleState.journeyGid === vehicleState.journeyProgressJourneyGid &&
    vehicleState.journeyProgressStatus ===
      JourneyProgressStatus.JOURNEY_PROGRESS_OFF_ROUTE
  );
}
